import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Hero.css';
import useLanguage from '../hooks/useLanguage';

const Hero = () => {
  const { t, isHebrew } = useLanguage();
  const iconSpacing = isHebrew ? 'ms-2' : 'me-2';

  return (
    <section id="home" className="hero-section">
      <div className="container">
        <div className="hero-center">
          <div className="hero-content text-center" data-aos="fade-up">
            <div className="hero-logo-wrapper">
              <img src="/hero-banner-cropped.jpg" alt="LevitzTax" className="hero-logo" />
            </div>
            <p className="lead text-white-50 mb-4 mx-auto" style={{ maxWidth: '600px' }}>
              {t('hero', 'tagline')}
            </p>
            <div className="hero-buttons">
              <a href="#services" className="btn btn-warning btn-lg hero-btn">
                <i className={`bi bi-briefcase ${iconSpacing}`}></i>
                {t('hero', 'servicesBtn')}
              </a>
              <a href="#contact" className="btn btn-outline-light btn-lg hero-btn">
                <i className={`bi bi-telephone ${iconSpacing}`}></i>
                {t('hero', 'contactBtn')}
              </a>
            </div>
          </div>
          <div className="hero-stats-row" data-aos="fade-up">
            <div className="hero-stats">
              <div className="stat-item">
                <div className="stat-number">5+</div>
                <div className="stat-label">{t('hero', 'statYears')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">200+</div>
                <div className="stat-label">{t('hero', 'statClients')}</div>
              </div>
              <div className="stat-item">
                <div className="stat-number">2</div>
                <div className="stat-label">{t('hero', 'statCountries')}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
